import React, { FC, useContext } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { RouteWrapper } from '../components/RouteWrapper';
import { AuthLayout } from '../layouts/AuthLayout';
import { AuthRecoverAccount } from '../components/AuthRecoverAccount/AuthRecoverAccount';
import { AuthEmail } from '../components/AuthEmail/AuthEmail';
import { AuthAccount } from '../components/AuthAccount/AuthAccount';
import { RedirectPreserveQuery } from '../components/RedirectPreserveQuery/RedirectPreserveQuery';
import { NotFoundComponent } from '../components/NotFound';
import { AuthSecondFactor } from '../components/AuthSecondFactor/AuthSecondFactor';
import { JoinPage } from '../pages/Join';
import { AuthContext } from '../contexts/AuthContext';
import { AccountRecoveryUpdatePassword } from '../components/AccountRecoveryUpdatePassword/AccountRecoveryUpdatePassword';
import { AuthSignUp } from '../components/AuthSignUp/AuthSignUp';
import { VerifyEmail } from '../pages/VerifyEmail';

export const guestRoot = '/auth';

/* eslint prettier/prettier: ["error", { printWidth: 1000 }] */
export const GuestRoutes = {
  Root: () => guestRoot,
  SignIn: () => `${guestRoot}/signin`,
  SignUp: () => `${guestRoot}/signup`,
  Account: () => `${guestRoot}/account`,
  // Choose: () => `${guestRoot}/choose`,
  Start: () => `/start`,

  SecondFactor: () => `${guestRoot}/signin/2fa`,

  ForgotPassword: () => `${guestRoot}/forgot-password`,
  ResetPassword: () => `${guestRoot}/reset-password`,

  Join: (token?: string) => `${guestRoot}/invitation/${token ?? ':token'}`,

  VerifyEmail: () => `${guestRoot}/verify-email`,
  // LegacyUserUpdatePassword: () => '/customer/user/update-password',
  // LegacyCustomerUpdatePassword: () => '/customer/admin/update-password',
  // LegacyAdminUpdatePassword: () => '/admin/update-password',
  //
  // LegacyUserSignIn: () => '/customer/user/signin',
  // LegacyCustomerSignIn: () => '/customer/admin/signin',
  // LegacyAdminSignIn: () => '/admin/signin',
  //
  // LegacyUserSignUp: () => '/customer/user/signup',
  // LegacyCustomerSignUp: () => '/customer/admin/signup',
  // LegacyAdminSignUp: () => '/admin/signup',
};

export const GuestRouter: FC = () => {
  const { identities } = useContext(AuthContext);

  return (
    <Switch>
      <RedirectPreserveQuery exact from={GuestRoutes.Start()} to={GuestRoutes.Root()} />
      {identities.length > 0 ? <RedirectPreserveQuery exact from={GuestRoutes.Root()} to={GuestRoutes.Account()} /> : <RedirectPreserveQuery exact from={GuestRoutes.Root()} to={GuestRoutes.SignIn()} />}

      <RouteWrapper exact path={GuestRoutes.SignIn()} component={AuthEmail} layout={AuthLayout} />

      <RouteWrapper exact path={GuestRoutes.Join()} component={JoinPage} layout={AuthLayout} />

      <RouteWrapper exact path={GuestRoutes.VerifyEmail()} component={VerifyEmail} layout={AuthLayout} />

      <RouteWrapper exact path={GuestRoutes.Account()} component={AuthAccount} layout={AuthLayout} />

      <RouteWrapper exact path={GuestRoutes.SecondFactor()} component={AuthSecondFactor} layout={AuthLayout} />

      <RouteWrapper exact path={GuestRoutes.ForgotPassword()} component={AuthRecoverAccount} layout={AuthLayout} />
      <RouteWrapper exact path={GuestRoutes.ResetPassword()} component={AccountRecoveryUpdatePassword} layout={AuthLayout} />

      <RouteWrapper exact path={GuestRoutes.SignUp()} component={AuthSignUp} layout={AuthLayout} />

      <Redirect exact from="/" to={GuestRoutes.Root()} />

      <RouteWrapper path={guestRoot} component={NotFoundComponent} layout={AuthLayout} />

      {/*<RedirectToAuth from={authenticatedRoot} />*/}
    </Switch>
  );
};
